export function GetQueryStringValue(name) {
  var qs = document.location.search
  qs = qs.substr(1, qs.length - 1)
  var retValue = ""
  var values = qs.split("&")
  for (var i = 0; i < values.length; i++) {
    var keyValuePair = values[i].split("=")
    if (keyValuePair[0] === name) {
      retValue = keyValuePair[1]
      break
    }
  }
  return retValue
}

export function isStringNullOrEmpty(stringValue) {
  if (stringValue === null) return true
  var type = typeof stringValue
  if (type !== "string" && type !== "number") return true
  return stringValue.toString().trim().length < 1
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

export function setCookie(cname, cvalue, exdays) {
  let d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = "expires=" + d.toUTCString()
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
}

export function getCookie(cname) {
  var name = cname + "="
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(";")
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == " ") {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ""
}

export function linkify(text) {
  var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi
  return text.replace(urlRegex, function(url) {
    return '<a target="_blank" href="' + url + '">' + url + "</a>"
  })
}
